/**
 * Statistiky → Provize (výpočtová sestava) — STATICKÁ mock data.
 *
 * Celá obrazovka je zatím jen návrh podoby k odsouhlasení klientem, nic se
 * nenačítá z API. Až bude podoba schválená, vymění se tenhle soubor za volání
 * backendu — struktura řádku odpovídá tomu, co má API vracet.
 *
 * Čísla jsou generovaná deterministicky (mulberry32 s pevným seedem), takže
 * při každém načtení vypadá sestava stejně. Názvy titulů, mutací, obchodníků
 * i zákazníků a sazby jsou převzaté z podkladů od klienta.
 */

/* ------------------------------------------------------------------ období */
export const OBDOBI = [
  '2025/05', '2025/06', '2025/07', '2025/08', '2025/09', '2025/10',
  '2025/11', '2025/12', '2026/01', '2026/02', '2026/03', '2026/04',
];

export const OBDOBI_AKTUALNI = '2026/04';

/** Období, která jsou v mockupu už uzavřená (sestava jen ke čtení). */
export const OBDOBI_UZAVRENA = [
  '2025/05', '2025/06', '2025/07', '2025/08', '2025/09', '2025/10',
  '2025/11', '2025/12', '2026/01', '2026/02',
];

/* ------------------------------------------------------------- obchodníci */
export const OBCHODNICI = [
  { id: 'OZ-VRV', jmeno: 'Vrbický Vít', vaha: 0.185 },
  { id: 'OZ-HAD', jmeno: 'Hadravová Štěpánka', vaha: 0.150 },
  { id: 'OZ-CHA', jmeno: 'Charvátová Gabriela', vaha: 0.128 },
  { id: 'OZ-MAT', jmeno: 'Maťátková Jitka', vaha: 0.115 },
  { id: 'OZ-TOM', jmeno: 'Tomaschková Zuzana', vaha: 0.098 },
  { id: 'OZ-LIB', jmeno: 'Libra Gustav', vaha: 0.082 },
  { id: 'OZ-BRE', jmeno: 'Brejchová Dana', vaha: 0.074 },
  { id: 'OZ-HRD', jmeno: 'Hrdá Růžena', vaha: 0.058 },
  { id: 'OZ-JAK', jmeno: 'Jakubec Karel', vaha: 0.046 },
  { id: 'OZ-VRL', jmeno: 'Vrbický Libor', vaha: 0.036 },
  { id: 'OZ-DOB', jmeno: 'Dobiáš Karel', vaha: 0.028 },
];

/* ------------------------------------------------------------------ tituly */
/* typ: 'nase' | 'partner' | 'special'
   objem = řádová velikost měsíčního obratu titulu (řídí počet položek)
   maxSleva = maximální sleva bez souhlasu (u partnerských se nad ni penalizuje) */
export const TITULY = [
  /* --- naše média --- */
  { id: 'T-NK', nazev: 'Noviny kraje – komplet', typ: 'nase', objem: 670090, maxSleva: 50 },
  { id: 'T-KLIC', nazev: 'Klíč', typ: 'nase', objem: 214050, maxSleva: 50 },
  { id: 'T-BOL', nazev: 'Boleslavan', typ: 'nase', objem: 197550, maxSleva: 60 },
  { id: 'T-CTRN', nazev: 'Čtrnáctka', typ: 'nase', objem: 160859, maxSleva: 50 },
  { id: 'T-ZLIN', nazev: 'Magazín Váš Zlín', typ: 'nase', objem: 151200, maxSleva: 50 },
  { id: 'T-OLK', nazev: 'Olomoucký kraj – komplet', typ: 'nase', objem: 163400, maxSleva: 50 },
  { id: 'T-USTI', nazev: 'Ústecké noviny', typ: 'nase', objem: 118080, maxSleva: 60 },
  { id: 'T-VYS', nazev: 'Kraj Vysočina – komplet', typ: 'nase', objem: 100882, maxSleva: 50 },
  { id: 'T-RADN', nazev: 'Radnice', typ: 'nase', objem: 93063, maxSleva: 70 },
  { id: 'T-JIZNI', nazev: 'Jižní listy', typ: 'nase', objem: 72400, maxSleva: 40 },
  { id: 'T-KLAUD', nazev: 'Klaudiánova nemocnice', typ: 'nase', objem: 66418, maxSleva: 60 },
  { id: 'T-UH', nazev: 'Zpravodaj města Uherské Hradiště', typ: 'nase', objem: 58900, maxSleva: 50 },
  { id: 'T-STRAK', nazev: 'Zpravodaj města Strakonice', typ: 'nase', objem: 52400, maxSleva: 50 },
  { id: 'T-VESEL', nazev: 'Veselské listy', typ: 'nase', objem: 49100, maxSleva: 50 },
  { id: 'T-MOST', nazev: 'Mostecké listy', typ: 'nase', objem: 47050, maxSleva: 50 },
  { id: 'T-WEB1', nazev: 'www.novinykraje.cz', typ: 'nase', objem: 44600, maxSleva: 40 },
  { id: 'T-KRAJ', nazev: 'Krajánek', typ: 'nase', objem: 41800, maxSleva: 50 },
  { id: 'T-PISEK', nazev: 'Zpravodaj města Písku', typ: 'nase', objem: 38200, maxSleva: 50 },
  { id: 'T-TABOR', nazev: 'Noviny táborské radnice', typ: 'nase', objem: 31500, maxSleva: 30 },
  { id: 'T-RUDNA', nazev: 'Život v Rudné', typ: 'nase', objem: 30400, maxSleva: 20 },
  { id: 'T-LOUNY', nazev: 'Lounský měsíčník', typ: 'nase', objem: 30200, maxSleva: 40 },
  { id: 'T-WEB2', nazev: 'www.fajnvylety.cz', typ: 'nase', objem: 12900, maxSleva: 40 },
  { id: 'T-JESEN', nazev: 'Naše město Jeseník', typ: 'nase', objem: 11300, maxSleva: 50 },
  { id: 'T-KVARY', nazev: 'Karlovarské radniční listy', typ: 'nase', objem: 9800, maxSleva: 50 },

  /* --- partnerská média (základ 12 %, resp. 8 %) --- */
  { id: 'P-OSM', nazev: 'Osmička', typ: 'partner', objem: 34000, maxSleva: 10, zaklad: 0.12 },
  { id: 'P-PLZ', nazev: 'Plzeňský Rozhled', typ: 'partner', objem: 31000, maxSleva: 15, zaklad: 0.12 },
  { id: 'P-ZAPR', nazev: 'Zápraží', typ: 'partner', objem: 24000, maxSleva: 10, zaklad: 0.12 },
  { id: 'P-SLAN', nazev: 'Slánské listy – PLUS', typ: 'partner', objem: 21000, maxSleva: 10, zaklad: 0.12 },
  { id: 'P-PERN', nazev: 'Týdeník Pernštejn', typ: 'partner', objem: 19000, maxSleva: 15, zaklad: 0.12 },
  { id: 'P-TEP', nazev: 'Žít Teplice', typ: 'partner', objem: 17000, maxSleva: 10, zaklad: 0.12 },
  { id: 'P-ECHO', nazev: 'Echo', typ: 'partner', objem: 16000, maxSleva: 15, zaklad: 0.12 },
  { id: 'P-HLAS', nazev: 'Hláska', typ: 'partner', objem: 14000, maxSleva: 10, zaklad: 0.12 },
  { id: 'P-LIPA', nazev: 'Lípa', typ: 'partner', objem: 13000, maxSleva: 10, zaklad: 0.12 },
  { id: 'P-TRUT', nazev: 'Trutnovinky', typ: 'partner', objem: 11000, maxSleva: 10, zaklad: 0.12 },
  { id: 'P-DECIN', nazev: 'Zpravodaj města Děčín', typ: 'partner', objem: 10000, maxSleva: 10, zaklad: 0.12 },
  { id: 'P-CBROD', nazev: 'Českobrodský zpravodaj', typ: 'partner', objem: 8000, maxSleva: 10, zaklad: 0.08 },
  { id: 'P-LBC', nazev: 'Liberecký zpravodaj', typ: 'partner', objem: 7000, maxSleva: 10, zaklad: 0.08 },
  { id: 'P-OBEL', nazev: 'Obelisk', typ: 'partner', objem: 6000, maxSleva: 10, zaklad: 0.08 },

  /* --- speciální operace (základ 10 %, bez bonusu) --- */
  { id: 'S-TISK', nazev: 'Redakční / grafické zpracování, tisk a distribuce', typ: 'special', objem: 96000, maxSleva: 20, zaklad: 0.10 },
  { id: 'S-INZ', nazev: 'Zajištění inzerce (externí tituly)', typ: 'special', objem: 62000, maxSleva: 20, zaklad: 0.10 },
];

export const TITUL_BY_ID = Object.fromEntries(TITULY.map(t => [t.id, t]));
export const OBCHODNIK_BY_ID = Object.fromEntries(OBCHODNICI.map(o => [o.id, o]));

/* ------------------------------------------------------------------ mutace */
export const MUTACE = [
  { id: 'M-BEN', titulId: 'T-NK', nazev: 'Benešovsko' },
  { id: 'M-CHOM', titulId: 'T-NK', nazev: 'Chomutovsko' },
  { id: 'M-HOD', titulId: 'T-NK', nazev: 'Hodonínsko' },
  { id: 'M-MB', titulId: 'T-NK', nazev: 'Mladoboleslavsko' },
  { id: 'M-P9', titulId: 'T-NK', nazev: 'Místní noviny Praha 9' },
  { id: 'M-PJV', titulId: 'T-NK', nazev: 'Místní noviny Praha-jihovýchod' },
  { id: 'M-PSEV', titulId: 'T-NK', nazev: 'Místní noviny Praha-sever' },
  { id: 'M-NYM', titulId: 'T-NK', nazev: 'Nymbursko' },
  { id: 'M-PVME', titulId: 'T-NK', nazev: 'Praha-východ (S) / Mělnicko' },
  { id: 'M-PZAP', titulId: 'T-NK', nazev: 'Praha-západ (S)' },
  { id: 'M-JIH', titulId: 'T-VYS', nazev: 'Jihlava' },
  { id: 'M-PEL', titulId: 'T-VYS', nazev: 'Pelhřimov' },
  { id: 'M-TRE', titulId: 'T-VYS', nazev: 'Třebíč' },
  { id: 'M-ZDAR', titulId: 'T-VYS', nazev: 'Žďár nad Sázavou' },
  { id: 'M-OLA', titulId: 'T-OLK', nazev: 'Olomoucko' },
  { id: 'M-PRER', titulId: 'T-OLK', nazev: 'Přerovsko' },
];

/* ------------------------------------------------------------------- sazby */
/** Pásma provize z vydání – naše média, podle plnění plánu vydání. */
export const PASMA_VYDANI = [0.08, 0.11, 0.14, 0.17, 0.20];

/** Bonusová provize podle měsíčního obratu obchodníka do našich médií. */
export const BONUS_PASMA = [
  { od: 40000, pct: 0.010 }, { od: 60000, pct: 0.020 }, { od: 80000, pct: 0.030 },
  { od: 100000, pct: 0.040 }, { od: 125000, pct: 0.045 }, { od: 150000, pct: 0.050 },
  { od: 175000, pct: 0.055 }, { od: 200000, pct: 0.060 }, { od: 250000, pct: 0.065 },
  { od: 300000, pct: 0.070 }, { od: 350000, pct: 0.075 }, { od: 400000, pct: 0.080 },
  { od: 450000, pct: 0.085 }, { od: 500000, pct: 0.090 }, { od: 550000, pct: 0.095 },
  { od: 600000, pct: 0.100 },
];

/** Korekce za pozdní úhradu – aplikuje se až na součet (J + K). */
export const PASMA_SPLATNOSTI = [
  { kod: 'ok', do: 45, koef: 1.0, nazev: '0–45 dní', popis: 'bez krácení', ikona: 'bi-check-circle-fill' },
  { kod: 'half', do: 90, koef: 0.5, nazev: '46–90 dní', popis: 'krácení 50 %', ikona: 'bi-exclamation-triangle-fill' },
  { kod: 'zero', do: Infinity, koef: 0.0, nazev: '91+ dní', popis: 'krácení 100 %', ikona: 'bi-x-circle-fill' },
];

export const TYPY_MEDIA = [
  { id: 'nase', label: 'Naše' },
  { id: 'partner', label: 'Partnerská' },
  { id: 'special', label: 'Speciální' },
];

export const pasmoSplatnosti = (dpd) =>
  PASMA_SPLATNOSTI.find(p => dpd <= p.do) || PASMA_SPLATNOSTI[PASMA_SPLATNOSTI.length - 1];

/* -------------------------------------------------------------- zákazníci */
const ZAKAZNICI = [
  'ŠKODA AUTO a.s.', 'České dráhy, a.s.', 'FOKUS optik a.s.', 'LEIFHEIT s.r.o.',
  'BTL Medical Technologies s.r.o.', 'Strojmetal Aluminium Forging a.s.',
  'ZF Electronics Klášterec s.r.o.', 'GEOSAN DEVELOPMENT s.r.o.', 'AURES Holdings a.s.',
  'CENTRUM ČERNÝ MOST s.r.o.', 'Galerie Butovice s.r.o.', 'Miloš Křeček KK, s.r.o.',
  'APEX Computer, s r.o.', 'HOLLEN CZ s. r. o.', 'KODAP MB, s.r.o.', 'PCT, s.r.o.',
  'Green Mladá Boleslav, s.r.o.', 'HT DVEŘE s.r.o.', 'KB CAR, s.r.o.', 'PM Vlková s.r.o.',
  'JURIS REAL, spol. s r.o.', 'OPIDUM - reality a.s.', 'Molík reality s.r.o.',
  'BERNECKER reality s.r.o.', 'RealitasFIN s.r.o.', 'VČRF Reality s.r.o.',
  'SERVIS HAMAS s.r.o.', 'GOLDBECK Prefabeton s.r.o.', 'Hope Global Europe, s.r.o.',
  'HORKA stavební, spol. s r.o.', 'Údržba komunikací s.r.o.', 'PLASTIA s.r.o.',
  'LE & CO - Ing. Jiří Lenc, s.r.o.', 'MEDICO spol.s r.o.', 'Flexi Clinic s.r.o.',
  'GYNREA s.r.o.', 'Rehabilitace INKA, s.r.o.', 'Alfadent, s.r.o.', 'Amber Plasma a.s.',
  'AUTOSALON DĚDEK, s.r.o.', 'AUTOSTAR CZ, a.s.', 'AUTOPLUS II, s.r.o.', 'SVA Cars, s.r.o.',
  'AVES Servisní a.s.', 'Kamenictví Dvořák s.r.o.', 'CLIMASTYL s.r.o.', 'MEMORY s. r. o.',
  'CODIN plus s.r.o.', 'TSM Global s.r.o.', 'Vinyllife s.r.o.', 'Bordado s.r.o.',
  'LION ART s.r.o.', 'JIMA production, s.r.o.', 'MIND to art s.r.o.', 'Robimaus s.r.o.',
  'Bohemia Baby s.r.o.', 'Regina, a.s.', 'VESNA, a.s.', 'REN company spol. s r.o.',
  'MARKER CZ s.r.o.', 'SPORTaS, s.r.o.', 'FOMEI s.r.o.', 'Ewing s.r.o.',
  'PV property s.r.o.', 'VI Group CZ s.r.o.', 'S.A.F. Praha spol. s r.o.',
  'Uhelné sklady Jihlava a.s.', '1. Pelhřimovská s.r.o.', 'FeMi - centrum Pacov, s.r.o.',
  'Vysoká škola polytechnická Jihlava', 'LITE HK, o.p.s.', 'Obec Vilémov',
  'Antonín Havel', 'Bc. Blanka Filipová', 'Denisa Vocásková', 'Ing. Josef Hrma',
  'Jan Kolář', 'Jiří Hrneček', 'Karel Severa', 'Karel Volenec', 'Lenka Dvořáková',
  'Mgr. Drahomír Havlíček', 'Michal Knot', 'Milan Roček', 'Olga Tenkrátová',
  'Pavel Bozděch', 'Pavel Jirásek', 'Pavel Vlk', 'Pavlína Kašičková',
  'Petr Chrudimský', 'Roman Jirkal', 'Tomáš Erben', 'Zdeněk Kochta', 'Šárka Šťástková',
];

/** Mediální agentury — u nich se plátce liší od inzerenta. */
const AGENTURY = [
  'Médea, a.s.', 'OMD Czech, a.s.', 'Dentsu Aegis Network Czech Republic s.r.o.',
  'Publicis Groupe CZ s.r.o.', 'Havas Media Group s.r.o.', 'MediaCom Praha s.r.o.',
  'Knowlimits s.r.o.', 'R2B2 s.r.o.',
];

const TYPY_INZERCE = [
  '1/1 strana', '1/2 strana', '1/3 strana', '1/4 strana', '1/8 strana', 'PR článek',
  'Řádková inzerce', 'Titulní strana', 'Zadní strana', 'Vkládaná inzerce', 'Banner web', 'Advertorial',
];

/** Sezónní koeficient – slabé léto, silný podzim a jaro. */
const SEZONA = {
  '2025/05': 0.98, '2025/06': 0.94, '2025/07': 0.61, '2025/08': 0.68, '2025/09': 1.06,
  '2025/10': 1.12, '2025/11': 1.15, '2025/12': 0.86, '2026/01': 0.79, '2026/02': 0.91,
  '2026/03': 1.03, '2026/04': 1.00,
};

/* ==========================================================================
   Generátor — deterministický, aby sestava vypadala při každém načtení stejně.
   ========================================================================== */
function generujPolozky() {
  let seed = 20260429;
  const rnd = () => {
    seed |= 0; seed = (seed + 0x6D2B79F5) | 0;
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  const between = (a, b) => a + rnd() * (b - a);
  const int = (a, b) => Math.floor(between(a, b + 1));
  const pick = arr => arr[Math.floor(rnd() * arr.length)];
  /* částka s dlouhým chvostem – hodně malých inzerátů, málo velkých */
  const castkaSkew = (min, max) => Math.round((min + (max - min) * Math.pow(rnd(), 2.4)) / 10) * 10;
  const pickOz = (pool) => {
    const total = pool.reduce((s, o) => s + o.vaha, 0);
    let r = rnd() * total;
    for (const o of pool) { r -= o.vaha; if (r <= 0) return o; }
    return pool[pool.length - 1];
  };

  /* Afinita OZ ↔ titul: každý titul má 1–3 „domovské" obchodníky. */
  const afinita = {};
  TITULY.forEach(t => {
    const pool = OBCHODNICI.slice();
    const n = int(1, 3);
    const sel = [];
    for (let i = 0; i < n; i++) {
      const o = pickOz(pool);
      sel.push(o);
      pool.splice(pool.indexOf(o), 1);
    }
    afinita[t.id] = sel;
  });

  const polozky = [];
  let faktCounter = 100;
  let inzCounter = 200;

  OBDOBI.forEach(obdobi => {
    const sez = SEZONA[obdobi] || 1;

    TITULY.forEach(t => {
      const mutace = MUTACE.filter(m => m.titulId === t.id);
      const objem = Math.round(t.objem * sez * between(0.82, 1.18));
      if (objem < 500) return;

      /* procento z vydání: naše média podle plnění plánu, ostatní pevný základ */
      const jVydani = t.typ === 'nase'
        ? PASMA_VYDANI[Math.min(PASMA_VYDANI.length - 1, Math.floor(Math.pow(rnd(), 0.8) * PASMA_VYDANI.length))]
        : (t.zaklad || 0.12);

      /* k datu sestavy je uhrazená jen část fakturovaného objemu */
      let zbyva = Math.round(objem * between(0.68, 0.88));
      const strop = Math.max(2400, objem * 0.055);
      let guard = 0;

      while (zbyva > 600 && guard++ < 120) {
        const oz = rnd() < 0.72 ? pickOz(afinita[t.id]) : pickOz(OBCHODNICI);
        const castka = Math.min(zbyva, castkaSkew(600, Math.min(zbyva, strop)));
        zbyva -= castka;

        const r = rnd();
        const dpd = r < 0.80 ? int(-18, 34) : (r < 0.93 ? int(46, 89) : int(91, 168));

        /* u partnerských titulů občas sleva nad maximum → penalizace provize */
        const nadLimit = t.typ === 'partner' && rnd() < 0.28;
        const slevaPct = nadLimit
          ? Math.round(between(t.maxSleva + 2, t.maxSleva + 28) * 10) / 10
          : Math.round(between(0, t.maxSleva) * 10) / 10;

        let jAuto = jVydani;
        if (t.typ === 'partner' && slevaPct > t.maxSleva) {
          /* −0,5 p.b. provize za každý 1 p.b. slevy nad maximum, nikdy do záporu */
          jAuto = Math.max(0, t.zaklad - 0.005 * (slevaPct - t.maxSleva));
        }

        const inzerent = pick(ZAKAZNICI);
        const zakaznik = rnd() < 0.16 ? pick(AGENTURY) : inzerent;

        polozky.push({
          id: 'I' + polozky.length,
          obdobi,
          obchodnikId: oz.id,
          cisloFaktury: String(212600000 + (faktCounter++ % 9000)),
          zakaznik,
          inzerent,
          cisloInzeratu: 'RV' + (2600000 + inzCounter++) + '/' + String(int(1, 12)).padStart(2, '0'),
          titulId: t.id,
          typMedia: t.typ,
          vydaniNazev: t.nazev + ' ' + obdobi,
          mutaceNazev: mutace.length ? pick(mutace).nazev : '',
          typInzerce: pick(TYPY_INZERCE),
          dpd,
          slevaPct,
          cenikovaCena: Math.round(castka / (1 - Math.min(0.95, slevaPct / 100))),
          platbaBezDph: castka,
          sazbaDph: rnd() < 0.9 ? 0.21 : 0.12,
          rucni: false,
          poznamka: '',
          jAuto: Math.round(jAuto * 10000) / 10000,
          kAuto: 0,
          jOverride: null,
          kOverride: null,
          lOverride: null,
          mOverride: null,
        });
      }
    });
  });

  /* Druhý průchod — bonusová provize z měsíčního obratu OZ do našich médií. */
  const obrat = {};
  polozky.forEach(p => {
    if (p.typMedia !== 'nase') return;
    const k = p.obchodnikId + '|' + p.obdobi;
    obrat[k] = (obrat[k] || 0) + p.platbaBezDph;
  });
  polozky.forEach(p => {
    if (p.typMedia !== 'nase') return;
    const o = obrat[p.obchodnikId + '|' + p.obdobi] || 0;
    let pct = 0;
    BONUS_PASMA.forEach(b => { if (o >= b.od) pct = b.pct; });
    p.kAuto = pct;
  });

  return polozky;
}

export const POLOZKY = generujPolozky();
